import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  IconButton,
  Typography,
} from "@material-ui/core";
import CloseIcon from '@material-ui/icons/Close';
import ChildrenElement from "../../../../models/HelperModels/ChildrenElement";

import classes from './index.module.scss';

interface ActionItem {
  title: string,
  color?: 'inherit' | 'primary' | 'secondary' | 'default',
  handler: () => void,
}

export type ModalProps = {
  isOpen: boolean;
  text?: string;
  title?: string;
  fullSize?: boolean;
  fixedHeight?: boolean;
  closeModal: () => void;
  hideCloseIcon?: boolean;
  hideTitleSection?: boolean;
  confirmButtonHandler?: () => void;
  closeOnConfirm?: boolean;
  declineButtonHandler?: () => void;
  confirmButtonText?: string;
  actionList?: ActionItem[]
  actionText?: string;
  declineButtonText?: string;
  isConfirmButtonDisabled?: boolean;
  dialogRef?: React.RefObject<HTMLDivElement>;
  children?: ChildrenElement;
};

export const GenericModal = ({
  isOpen,
  closeModal,
  text,
  title,
  children,
  confirmButtonHandler,
  hideCloseIcon = false,
  hideTitleSection = false,
  closeOnConfirm = true,
  declineButtonHandler,
  confirmButtonText,
  actionList,
  actionText,
  declineButtonText,
  fixedHeight = false,
  fullSize = false,
  isConfirmButtonDisabled = false,
  dialogRef,
}: ModalProps) => {
  const onConfirmButtonHandler = () => {
    if (closeOnConfirm) {
      closeModal();
    }
    if (!confirmButtonHandler) {
      return;
    }
    confirmButtonHandler();
  }

  const onDeleteButtonHandler = () => {
    closeModal();
    if (!declineButtonHandler) {
      return;
    }
    declineButtonHandler();
  }

  return (
    <Dialog
      open={isOpen}
      onClose={closeModal}
      fullWidth
      maxWidth={fullSize ? 'lg' : "sm"}
      ref={dialogRef}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      classes={{
        paper: classes.paper,
      }}
    >
      {hideTitleSection ? (null) : (
        <DialogTitle id="alert-dialog-title">
          <Grid container className={classes.title}>
            <Grid item xs={11}>
              <Typography variant="h6">{title}</Typography>
            </Grid>
            {hideCloseIcon ? (null) : (
              <Grid item xs={1}>
                <IconButton onClick={closeModal} className={classes.closeButton}>
                  <CloseIcon />
                </IconButton>
              </Grid>
            )}
          </Grid>
        </DialogTitle>
      )}
      <DialogContent
        className={fixedHeight ? classes.fixedHeight : ''}
      >
        {
          children ?
            children : (
              <DialogContentText
                id="alert-dialog-description"
                className={classes.contentText}
              >
                {text}
              </DialogContentText>
            )
        }
      </DialogContent>
      <DialogActions className={classes.footer}>
        {actionText && (
          <Grid container justifyContent="flex-start" alignItems="center">
            <Typography variant="subtitle1">{actionText}</Typography>
          </Grid>
        )}
        <Grid container justifyContent="flex-end">
          {confirmButtonText && (
            <Grid item>
              <Button
                onClick={onConfirmButtonHandler}
                color="secondary"
                disabled={isConfirmButtonDisabled}
              >
                {confirmButtonText}
              </Button>
            </Grid>
          )}
          {declineButtonText && (
            <Grid item>
              <Button onClick={onDeleteButtonHandler} color="primary" autoFocus>
                {declineButtonText}
              </Button>
            </Grid>
          )}
          {actionList && (
            actionList.map((action) => {
              return (
                <Grid item key={action.title}>
                  <Button onClick={action.handler} color={action.color || 'default'} autoFocus>
                    {action.title}
                  </Button>
                </Grid>
              )
            })
          )}
        </Grid>
      </DialogActions>
    </Dialog>
  );
};
